import gql from 'graphql-tag';

export default gql`
  query UserAIFcKey {
    currentUser {
      sandbox {
        aiFcKey
      }
    }
  }
`